// Wyszukiwarka Bazy wiedzy, działa w przeglądarce. Treść artykułów doczytuje dopiero przy
// pierwszym wyszukiwaniu: na produkcji jeden plik z prerenderu, lokalnie pliki .md.
import { mdNaTekst } from './mdNaTekst'
import { etykietyArtykulu } from './tagi'

const POLSKIE = { ą: 'a', ć: 'c', ę: 'e', ł: 'l', ń: 'n', ó: 'o', ś: 's', ź: 'z', ż: 'z' }

// Zachowuje długość tekstu, dzięki czemu miejsca trafień pasują do oryginału.
export const normalizuj = (tekst) =>
  String(tekst || '').toLowerCase().replace(/[ąćęłńóśźż]/g, (z) => POLSKIE[z])

const POMIJANE = new Set(['a', 'i', 'o', 'u', 'v', 'w', 'z', 'na', 'do', 'od', 'po', 'za', 'we', 'ze', 'to', 'co', 'czy', 'jak', 'sie', 'dla', 'ile', 'kto', 'oraz', 'jest'])

const SYNONIMY = [
  ['falownik', 'inwerter'],
  ['magazyn', 'bateria', 'akumulator'],
  ['panel', 'modul'],
  ['fotowoltaika', 'pv'],
  ['wallbox', 'ladowarka'],
]

// Prosty rdzeń zamiast odmiany: „magazynów” i „magazynu” mają szukać tego samego.
const rdzen = (slowo) => {
  if (/\d/.test(slowo) || slowo.length < 5) return slowo
  return slowo.slice(0, slowo.length >= 7 ? -2 : -1)
}

const warianty = (slowo) => {
  const r = rdzen(slowo)
  const grupa = SYNONIMY.find((g) => g.some((w) => w === r || w.startsWith(r) || r.startsWith(w)))
  return [...new Set([r, ...(grupa ? grupa.map(rdzen) : [])])]
}

const regexp = (fragment) => {
  const bezpieczny = fragment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  // Kody modeli („lp3” w „sg05lp3”) szukamy w środku słowa, resztę od początku słowa.
  // Końcówka łapie całe słowo, żeby podświetlenie nie urywało się na rdzeniu.
  return /\d/.test(fragment) ? `${bezpieczny}[a-z0-9]*` : `\\b${bezpieczny}[a-z0-9]*`
}

export const rozbijZapytanie = (zapytanie) =>
  normalizuj(zapytanie)
    .split(/[^a-z0-9]+/)
    .filter((s) => s && !POMIJANE.has(s))
    .map((s) => new RegExp(warianty(s).map(regexp).join('|'), 'g'))

const ileTrafien = (re, tekst) => (tekst.match(re) || []).length

const fragmentZTrafieniem = (tekst, wzorce) => {
  const norm = normalizuj(tekst)
  let start = -1
  wzorce.forEach((re) => {
    re.lastIndex = 0
    const m = re.exec(norm)
    if (m && (start < 0 || m.index < start)) start = m.index
    re.lastIndex = 0
  })
  if (start < 0) return ''
  const od = Math.max(0, tekst.lastIndexOf(' ', Math.max(0, start - 60)) + 1)
  const doKonca = tekst.indexOf(' ', start + 120)
  const koniec = doKonca < 0 ? tekst.length : doKonca
  return `${od > 0 ? '… ' : ''}${tekst.slice(od, koniec)}${koniec < tekst.length ? ' …' : ''}`
}

// Każde słowo z zapytania musi się gdzieś znaleźć. Tytuł i tagi ważą najwięcej, treść najmniej.
export const szukaj = (artykuly, zapytanie, teksty = {}) => {
  const wzorce = rozbijZapytanie(zapytanie)
  if (!wzorce.length) return []
  const fraza = normalizuj(zapytanie).trim()
  const wyniki = []
  artykuly.forEach((a) => {
    const tytul = normalizuj(a.title)
    const lead = normalizuj(a.lead)
    const temat = normalizuj(`${a.breadcrumbTopic || ''} ${a.category || ''}`)
    const tagi = normalizuj(etykietyArtykulu(a.slug).join(' '))
    const tresc = teksty[a.slug] || ''
    const trescNorm = normalizuj(tresc)
    let punkty = 0
    for (const re of wzorce) {
      const wTytule = ileTrafien(re, tytul)
      const wTemacie = ileTrafien(re, temat)
      const wTagach = ileTrafien(re, tagi)
      const wLeadzie = ileTrafien(re, lead)
      const wTresci = ileTrafien(re, trescNorm)
      if (!wTytule && !wTemacie && !wTagach && !wLeadzie && !wTresci) return
      punkty += (wTytule ? 12 : 0) + (wTagach ? 10 : 0) + (wTemacie ? 6 : 0) + (wLeadzie ? 5 : 0) + Math.min(wTresci, 5)
    }
    if (tytul.includes(fraza)) punkty += 20
    const wNaglowku = wzorce.every((re) => ileTrafien(re, tytul) || ileTrafien(re, lead))
    wyniki.push({ artykul: a, punkty, fragment: wNaglowku ? '' : fragmentZTrafieniem(tresc, wzorce) })
  })
  return wyniki.sort(
    (x, y) => y.punkty - x.punkty || String(y.artykul.updatedAt).localeCompare(String(x.artykul.updatedAt))
  )
}

// Dzieli tekst na kawałki do podświetlenia trafień.
export const podzielNaTrafienia = (tekst, wzorce) => {
  const norm = normalizuj(tekst)
  const zakresy = []
  wzorce.forEach((re) => {
    re.lastIndex = 0
    let m = re.exec(norm)
    while (m) {
      if (!m[0]) break
      zakresy.push([m.index, m.index + m[0].length])
      m = re.exec(norm)
    }
    re.lastIndex = 0
  })
  if (!zakresy.length) return [{ tekst, trafienie: false }]
  zakresy.sort((a, b) => a[0] - b[0])
  const kawalki = []
  let poz = 0
  zakresy.forEach(([od, doZnaku]) => {
    if (doZnaku <= poz) return
    const start = Math.max(od, poz)
    if (start > poz) kawalki.push({ tekst: tekst.slice(poz, start), trafienie: false })
    kawalki.push({ tekst: tekst.slice(start, doZnaku), trafienie: true })
    poz = doZnaku
  })
  if (poz < tekst.length) kawalki.push({ tekst: tekst.slice(poz), trafienie: false })
  return kawalki
}

let obietnicaTekstow = null

const zPlikowMd = (artykuly) =>
  Promise.all(
    artykuly.map((a) =>
      fetch(a.mdPath)
        .then((r) => (r.ok ? r.text() : ''))
        .then((md) => [a.slug, mdNaTekst(md)])
        .catch(() => [a.slug, ''])
    )
  ).then(Object.fromEntries)

export const wczytajTeksty = (artykuly) => {
  if (!obietnicaTekstow) {
    obietnicaTekstow = fetch(`${process.env.PUBLIC_URL || ''}/knowledge-base/search-index.json`)
      .then((r) => {
        if (!r.ok) throw new Error('brak indeksu')
        return r.json()
      })
      .then((dane) => Object.fromEntries(dane.articles.map((a) => [a.slug, a.tekst])))
      // Lokalnie indeksu nie ma, a serwer deweloperski zwraca wtedy stronę HTML.
      .catch(() => zPlikowMd(artykuly))
  }
  return obietnicaTekstow
}
